import React, { Component } from 'react'
import { connect } from 'react-redux';
import _, { isEmpty, get, cloneDeep } from 'lodash';
import PropTypes from 'prop-types';

import asyncRoute from '../../../../helpers/hoc/asyncRoute';
import Table from '../../../../components/CustomTable';
import routes from '../../../../routes';
import { options, formFields, categoryOptions, statusOptions, SsOptions } from './constant';
import { getTenantAction, deleteTenantAction, addTenantAction, editTenantAction, postAllTenantsFetchBalanceAction } from '../../../../actions';
import { Link, withRouter } from "react-router-dom";
import { PERMISSION } from '../../../../constants/permission';
import { checkTablePermission, checkPermission } from '../../../../utils/route-auth';
import { Checkbox } from 'semantic-ui-react';
import { handleFieldError } from '../../../../utils/form-validation';
import SingleSelect from "../../../../components/FormElements/SingleSelect";
import ModalConfirmation from '../../../../components/ModalConfirmation';
import Select from "../../../../components/FormElements/Select";
import ToastModal from "../../../../components/ToastModal";
import { getDateFromUtcToSpecificZone, getTenantTimeZone } from '../../../../selectors';
import moment from 'moment';

const Tabs = asyncRoute(() => import('../../../../components/Tabs'));
const Card = asyncRoute(() => import('../../../../components/Card'));
const BreadCrumb = asyncRoute(() => import('../../../../components/BreadCrumb'));

class Tenant extends Component {
  constructor(props) {
    super(props);
    this.state = {
      optionsList: options,
      SelfServeOptionsList: SsOptions,
      form: { category: 2, status: 2 },
      touched: {},
      errors: {},
      submited: false,
      platformList: [],
      tenantList: [],
      confirmationOpen: false,
      confirmationInfo: '',
      enableToast: false,
      toastStatus: "",
      toastMsg: "",
      confirmationMsg: "",
      method: "",
      tableRow: {},
      tableAction: {},
      currentTable: 1,
      currentTableName: 'manageService',
      selfServeList: [],
      statusSuccess: false
    };
  }

  componentWillMount() {
    let optionsList = checkTablePermission({ add: PERMISSION.ADMIN.TENANT.MANAGESERVICE.ADD, edit: PERMISSION.ADMIN.TENANT.MANAGESERVICE.EDIT, view: PERMISSION.ADMIN.TENANT.MANAGESERVICE.VIEW }, cloneDeep(options));
    let SelfServeOptionsList = checkTablePermission({ add: PERMISSION.ADMIN.TENANT.SELFSERVE.ADD, edit: PERMISSION.ADMIN.TENANT.SELFSERVE.EDIT, view: PERMISSION.ADMIN.TENANT.SELFSERVE.VIEW }, cloneDeep(SsOptions));

    const { tenantId } = this.props;

    const targetTimeZone = getTenantTimeZone(tenantId)

    optionsList.columns.forEach((dataCol, index) => {
      if (dataCol.name == "modifiedOn") {
        optionsList.columns[index].component = (row) => row.modifiedOn ? moment(getDateFromUtcToSpecificZone({ date: row.modifiedOn, targetTimeZone: targetTimeZone })).format('YYYY-MM-DD') : '-'
      }
    })

    SelfServeOptionsList.columns.forEach((dataCol, index) => {
      if (dataCol.name == "modifiedOn") {
        SelfServeOptionsList.columns[index].component = (row) => row.modifiedOn ? moment(getDateFromUtcToSpecificZone({ date: row.modifiedOn, targetTimeZone: targetTimeZone })).format('YYYY-MM-DD') : '-'
      }
    })

    this.setState({ optionsList, SelfServeOptionsList });
    let isAuthenticated = JSON.parse(localStorage.getItem('AuthData'));
    if (isEmpty(isAuthenticated)) {
      const { history } = this.this.props;
      history.push(routes.preSignIn);
    }
    this.getList()
  }

  getList = async () => {
    const { getTenantAction, tenantId, authToken, userId } = this.props;
    const { responseCode: { status = "" } = {}, responseList = [] } = await getTenantAction({ tenantId, authToken, userId });
    if (status.toLowerCase() == "success") {
      await this.FecthAllTenantsBalance(responseList)
    }
  }

  FecthAllTenantsBalance = async (enantListAllData) => {
    try {
      const { tenantId, userId, authToken, postAllTenantsFetchBalanceAction } = this.props
      const payload = {
        tenantId: tenantId
      }

      const { responseCode: { status = "" } = {}, response = [] } = await postAllTenantsFetchBalanceAction({ tenantId, authToken, userId, payload });
      if (status.toLowerCase() == "success") {
        const manageService = enantListAllData.filter((data) => data.tenantMode == 0)
        const selfServeList = enantListAllData.filter((data) => data.tenantMode == 1)

        const mergedArray = manageService.map((data) => {
          const matchingItem2 = response && response.find((data2) => data2.tenantId === data.tenantId);
          if (matchingItem2) {
            // If a match is found, merge the data
            return { ...data, ...matchingItem2 };

          } else {
            // If no match is found, return the original item from array1
            return data;
          }
        })

        this.setState({ tenantList: mergedArray, tenantListAllData: mergedArray, selfServeList });
      }
    } catch (error) {
      console.log(error);
    }
  }

  handleChange = (e) => {
    let { form } = this.state;
    let { value, name } = e.target;
    form[name] = value;
    this.setState({ form });
  };

  handleTouch = (e) => {
    let { touched, form, errors } = this.state;
    let { error } = handleFieldError(form[e.target.name], formFields[e.target.name]);
    errors[e.target.name] = error;
    touched[e.target.name] = true;
    this.setState({ touched, errors });
  };


  handleAction = (row, action) => {
    const { match, history } = this.props;
    if (action.type === 'edit') {
      this.handleEdit(row, match, history);
    } else if (action.type === 'recActive') {
      if (row.accountType == 1) {
        this.setState({ enableToast: true, toastStatus: "Fail", toastMsg: "Can't Edit Account", method: "dont see" });
        return
      }

      else if (row.tenantId) {
        if (row.tenantType == "Platform Manager") {
          if (checkPermission({
            permissions: [PERMISSION.ADMIN.MGRTENANT.EDIT]
          })) {
            this.setState({ enableToast: true, toastStatus: "Fail", toastMsg: "Permission Denied !", method: "dont see" });
            // history.push(`${match.path}/${routes.admin.tenant.editMgr}/${row.tenantId}`)
          }
          else {
            this.setState({ enableToast: true, toastStatus: "Fail", toastMsg: "Can't Edit Manager Tenant", method: "dont see" });
            return
          }
        } else {
          this.setState({ enableToast: true, confirmationMsg: "Please confirm if you wish to update this record.", toastMsg: "", toastStatus: "", method: 'recActiveStatus', tableRow: row, tableAction: action });
        }
      }
    } else if (action.type === 'view') {
      this.handleView(row, match, action);
    }
  }

  toggleModal = (confirmation) => {
    const { confirmationOpen } = this.state;
    this.setState({ confirmationOpen: !confirmationOpen, confirmationInfo: confirmation });
  };

  confirmationCallBack = (success, info) => {
    const { confirmationOpen } = this.state;
    if (success && info.action.type === 'Confirmation') {
      this.submitForm();
    } else if (info.action.type === 'alert') {
      this.setState({ confirmationOpen: !confirmationOpen }, () => {
        // const { history } = this.props;
        // history.push(`/${routes.mainRoute}/${routes.containers.admin}/${routes.admin.user.name}`);
      });
      return;
    }
    this.setState({ confirmationOpen: false });
  };

  handleEdit(row, match, history) {
    if (row.accountType == 1) {
      // const info = { action: { confirmationMessage: "Can't Edit Account", type: 'error' } };
      // this.toggleModal(info);
      this.setState({ enableToast: true, toastStatus: "Fail", toastMsg: "Can't Edit Account", method: "dont see" });

      return
    }
    else {
      if (row.tenantType == "Platform Manager") {
        console.log(checkPermission({
          permissions: [PERMISSION.ADMIN.MGRTENANT.EDIT]
        }));
        if (checkPermission({
          permissions: [PERMISSION.ADMIN.MGRTENANT.EDIT]
        })) {
          // history.push(`${match.path}/${routes.admin.tenant.editMgr}/${row.tenantId}`)
          // const info = { action: { confirmationMessage: "contact to ion manager to edit platform manager", type: 'error' } };
          // this.toggleModal(info);
          this.setState({ enableToast: true, toastStatus: "Fail", toastMsg: "Contact to ION Manager to edit Platform Manager", method: "dont see" });

        }
        else {
          // const info = { action: { confirmationMessage: "Can't Edit Manager Tenant", type: 'error' } };
          // this.toggleModal(info);
          this.setState({ enableToast: true, toastStatus: "Fail", toastMsg: "Can't Edit Manager Tenant", method: "dont see" });

        }
      }
      else {
        history.push(`${match.path}/${routes.admin.tenant.edit}/${row.tenantId}`, { tenantType: row.tenantType });
      }
    }
  }

  async handleView(row, match, action) {
    const { history } = this.props;
    if (row.accountType == 1) {
      // const info = { action: { confirmationMessage: "Can't view Account", type: 'error' } };
      // this.toggleModal(info);
      this.setState({ enableToast: true, toastStatus: "Fail", toastMsg: "Can't view Account", method: "dont see" });
      return
    }

    else if (row.tenantType == "Platform Manager") {
      // const info = { action: { confirmationMessage: "Can't view plaftform manager tenant", type: 'error' } };
      // this.toggleModal(info);
      this.setState({ enableToast: true, toastStatus: "Fail", toastMsg: "Can't view Plaftform manager Tenant", method: "dont see" });
    }
    else {
      history.push(`${match.path}/${routes.admin.tenant.view}/${row.tenantId}`);
    }
  }

  async handleStatus(row, action) {
    const { tenantId, authToken, userId, editTenantAction, addTenantAction } = this.props;
    const { responseCode: { status = '' }, responseList } = await editTenantAction({ tenantId, authToken, userId, editId: row.tenantId });
    if (status === 'Success') {
      const payload = responseList[0]
      //  console.log(obj.isActive,"e")
      payload.isActive = (payload.isActive == "1" ? 0 : 1)
      let addParams = { action: 'update' };
      const res = await addTenantAction({ tenantId, authToken, userId, payload, addParams })
      if (res.responseCode.status === 'Success') {
        //   console.log('called')
        // const info = { action: { confirmationMessage: res.msg, type: 'alert' } };
        // this.toggleModal(info);
        this.toast(res.responseCode.status, res.responseCode.msg)
        this.setState({ statusSuccess: true });
        // const { getTenantAction, tenantId, authToken, userId } = this.props;
        // this.getList();
      }
      else {
        // const info = { action: { confirmationMessage: res.msg, type: 'error' } };
        // this.toggleModal(info);
        this.toast(res.responseCode.status, res.responseCode.msg)
      }
    }
  }


  handleFilter = (e) => {
    e.preventDefault();
    const { form, tenantListAllData } = this.state;
    let filteredList = tenantListAllData;

    const statusId = statusOptions.find(item => item.value == form.status);
    const categoryId = categoryOptions.find(cat => cat.value == form.category);

    if ((form.status == 2 || String(form.status).toLowerCase() == "both") && (form.category == 2 || String(form.category).toLowerCase() == "both")) {
      filteredList = tenantListAllData;
    } else {
      if (statusId && statusId.id !== 2) {
        filteredList = filteredList.filter((item) => item.isActive == statusId.id);
      }
      if (categoryId && categoryId.id !== 2) {
        filteredList = filteredList.filter((item) => item.accountType == categoryId.id);
      }
    }
    this.setState({ tenantList: filteredList });
  }


  toast = (status, msg) => {
    this.setState({ enableToast: true, toastStatus: status, toastMsg: msg });
    return;
  }

  confirmationCallbackModel = (id) => {
    const { method, tableAction, tableRow } = this.state;
    this.setState({ enableToast: false }, () => {
      if (method === "dont see") {
        // this.deleteHierarchy();
      }
      else if (method === "recActiveStatus") {
        this.handleStatus(tableRow, tableAction);
      }

    });

  }


  handleToastStatus = (status) => {
    const { method, statusSuccess } = this.state;

    this.setState({ enableToast: status }, () => {
      if (method === "dont see") {
        // this.getHierarchy();
      }
      else if (method === "recActiveStatus" && statusSuccess) {
        this.getList();
        this.setState({ statusSuccess: false });
      }
    });
  }


  render() {
    const { tenantListAll } = this.props;
    const { optionsList, form, touched, errors, submited, tenantList, confirmationOpen, confirmationInfo,
      enableToast, toastMsg, toastStatus, confirmationMsg, currentTable, currentTableName, SelfServeOptionsList, selfServeList } = this.state;
    return (<>
      {confirmationOpen && (<ModalConfirmation
        open={confirmationOpen}
        onClose={this.toggleModal}
        confirmationInfo={confirmationInfo}
        handelConfirmationMessage={this.confirmationCallBack}
      />)}

      {
        enableToast && <ToastModal
          enableToast={enableToast}
          status={toastStatus}
          msg={toastMsg}
          // path={routes.containers.mediaPlan}
          idProps={this.props}
          handleConfirmation={this.confirmationCallbackModel}
          handleToastStatus={this.handleToastStatus}
          confirmationMsg={confirmationMsg}
          poc={true}
        />
      }

      <div className="main-panel ion form__style">
        <div className="content-wrapper">
          <BreadCrumb />
          <div className="row mt-3">
            {/* <Card>

              <Tabs container="admin" />
            </Card> */}
            <Tabs container="admin" />
            <Card >
              <div className='d-flex justify-content-end'>
                {
                  checkPermission({
                    permissions: [PERMISSION.ADMIN.TENANT.MANAGESERVICE.ADD]
                  }) &&
                  <Link
                    to={`/${routes.mainRoute}/${routes.containers.admin}/${routes.admin.tenant.name}/${routes.admin.tenant.add}`}
                    className='text-white text-decoration-none btn btn-primary ml-4'
                    style={{ height: 35, border: "1px solid #303890", color: "#303890", background: "#fff", marginBottom: 10, borderRadius: 6 }}
                  >
                    <i className="ti ti-plus ti-sm"></i> Tenant
                  </Link>
                }
              </div>

              <ul class="nav nav-tabs customNav ml-1 mb-4" role="tablist">
                <li class="nav-item">
                  {
                    checkPermission({
                      permissions: [PERMISSION.ADMIN.TENANT.MANAGESERVICE.VIEW]
                    }) &&
                    <button
                      type="button"
                      className={`${currentTable === 1 ? "nav-link active" : "nav-link"} customNavButton`}
                      onClick={() =>
                        this.setState({
                          currentTableName: "manageService",
                          currentTable: 1,
                        })}
                      href="javascript:void(0);" role="tab"
                    >
                      Manage Service
                    </button>
                  }
                </li>
                <li class="nav-item">
                  {
                    checkPermission({
                      permissions: [PERMISSION.ADMIN.TENANT.SELFSERVE.VIEW]
                    }) &&
                    <button
                      type="button"
                      className={`${currentTable === 2 ? "nav-link active" : "nav-link"} customNavButton`}
                      onClick={() =>
                        this.setState({
                          currentTableName: "self-server-tenant",
                          currentTable: 2,
                        })
                      }
                      href="javascript:void(0);" role="tab"
                    >
                      Self Serve
                    </button>
                  }
                </li>
              </ul>
              {
                currentTableName == 'manageService' ?
                  <div className="tab-pane fade show active my-4" >

                    <div class="accordion" id="accordionWithIcon">
                      <div class="card accordion-item mb-2">
                        <h2 class="accordion-header d-flex align-items-center">
                          <button type="button" class="accordion-button" data-bs-toggle="collapse" data-bs-target="#accordionWithIcon-1" aria-expanded="true">
                            <i class="ti ti-filter ti-xs me-2"></i>
                            Filter Tenant
                          </button>
                        </h2>

                        <div id="accordionWithIcon-1" class="accordion-collapse collapse show" >
                          <div class="accordion-body">
                            <div className="row">
                              <div className="col-md-12 px-0">
                                <form className="form-inline pt-2 pb-2 d-flex align-items-end" id="filterform" style={{ display: 'block', "border-radius": '5px' }}>
                                  <div className="col-sm-12 col-md-3 flex-column d-flex pt-2">
                                    <Select
                                      onChange={this.handleChange}
                                      onBlur={this.handleTouch}
                                      value={form[formFields.category.key]}
                                      setting={formFields[formFields.category.key]}
                                      error={errors[formFields.category.key]}
                                      submited={submited}
                                      touched={touched[formFields.category.key]}
                                      allowClear={true}
                                      options={categoryOptions}
                                    />

                                  </div>
                                  <div className="col-sm-12 col-md-3 d-flex pt-2 pt-md-2 flex-column">
                                    <Select
                                      onChange={this.handleChange}
                                      onBlur={this.handleTouch}
                                      value={form[formFields.status.key]}
                                      setting={formFields[formFields.status.key]}
                                      error={errors[formFields.status.key]}
                                      submited={submited}
                                      touched={touched[formFields.status.key]}
                                      allowClear={true}
                                      options={statusOptions}
                                    />
                                  </div>
                                  <div className="col-sm-12 col-md-3 d-flex pt-2">
                                    <button type="submit" onClick={(e) => this.handleFilter(e)} className='text-white text-decoration-none btn btn-primary ml-4 shadow-none'
                                      style={{ height: 35, border: "1px solid #303890", color: "#303890", background: "#fff", marginBottom: 10, borderRadius: 6 }}><i className='mdi mdi-account-check'></i>Apply</button>
                                  </div>
                                </form>
                              </div>
                              <br />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="campaign-adj">
                      <div className="campaign-list-adj table-responsive">
                        <Table
                          options={optionsList}
                          data={tenantList || []}
                          handelAction={this.handleAction}
                        />
                      </div>
                    </div>
                  </div>
                  :
                  <div className="campaign-adj">
                    <div className="campaign-list-adj table-responsive">
                      <Table
                        options={SelfServeOptionsList}
                        data={selfServeList || []}
                        handelAction={this.handleAction}
                      />
                    </div>
                  </div>
              }
            </Card>
          </div>
        </div>
      </div></>
    );
  }
}

export default withRouter(connect(
  (state) => ({
    tenantListAll: get(state, 'app.tenantListAll.responseList', []),
    tenantId: get(state, 'app.preSignInState.tenantId', ''),
    userId: get(state, 'app.preSignInData.userId', ''),
    authToken: get(state, 'app.signInData.authToken', ''),
  }), {
  getTenantAction,
  deleteTenantAction,
  addTenantAction,
  editTenantAction,
  postAllTenantsFetchBalanceAction
}
)(Tenant));

Tenant.propTypes = {
  tenantListAll: PropTypes.array,
  tenantId: PropTypes.number,
  userId: PropTypes.number,
  authToken: PropTypes.string,
  getTenantAction: PropTypes.func,
};